<li class="nav-item" *ngIf="turn && buttonMode && _data.configuration['finishTurnButton'] || (_data.configuration['activeSupervisor'] && _data.configuration['finishSupervisorDesk'] && isAttentionTurn)">
    <button class="nav-link btn btn-dark text-white mr-2" (click)="close(getPrekindId())"><i class="fa fa-times" aria-hidden="true"></i> {{ "closeAttention" | language }}</button>
</li>

<div class="container-fluid" *ngIf="turn && !buttonMode">
    <div class="row">
        <div class="col-md-12 mt-3 mb-3">
            <h4>{{ "closeAttention" | language }}
                <button (click)="removeSearch()" class="btn btn-default btn-sm d-inline-block float-right">{{ "clearFilters" | language }}</button>
                <input class="form-control form-control-sm d-inline-block mr-2 ml-2 w-25 float-right" type="text" (change)="searchFilter()" (keyup)="searchFilter()" [(ngModel)]="search" [placeholder]="'searchatype' | language">

            </h4>
            <hr>

        </div>
        <ng-container *ngFor="let a of orderedAtypes() | filterBy: listFilter; let i = index">
            <div class="col-md-3 mb-3" *ngIf="(_data.configuration['phoneKindId'] == _data.turn['prekind_id']) || (_data.configuration['phoneKindId'] !=  a.id)">
                <button (click)="close(a.id)" [ngStyle]="{'font-size': _data.configuration.fontSize}" [ngClass]="a.id != _data.turn['prekind_id'] ? 'btn btn-dark btn-block btn-lg mb-2' : 'btn btn-primary btn-block btn-lg mb-2'">
            <i *ngIf="_data.configuration['phoneKindId'] == a.id" class="fa fa-phone" aria-hidden="true"></i>
            {{ a.name }}
          </button>
            </div>
        </ng-container>
        <div class="col-md-3 mb-3" *ngIf="_data.configuration['phoneKindId'] != _data.turn['prekind_id']">
            <button (click)="close(-1)" [ngStyle]="{'font-size': _data.configuration.fontSize}" class="btn btn-dark btn-block btn-lg">{{ "hasNotCome" | language }}</button>
        </div>
    </div>
</div>
